<template>
  <transition name="notif-fade">
    <div v-if="notif" class="fixed right-4 top-6 z-60">
      <div :class="['px-4 py-2 rounded shadow-lg text-sm font-medium', bgClass]">
        {{ notif.message }}
      </div>
    </div>
  </transition>
</template>

<script setup>
import { computed } from 'vue'
import { useNotification } from '@/stores/notificationStore'

const { current } = useNotification()

const notif = current

const bgClass = computed(() => {
  if (!notif || !notif.value) return 'bg-gray-800 text-white'
  const t = notif.value.type
  if (t === 'success') return 'bg-green-600 text-white'
  if (t === 'error') return 'bg-red-600 text-white'
  if (t === 'warn') return 'bg-yellow-500 text-black'
  return 'bg-gray-800 text-white'
})
</script>

<style scoped>
.notif-fade-enter-active, .notif-fade-leave-active {
  transition: opacity 0.25s ease, transform 0.25s ease;
}
.notif-fade-enter-from {
  opacity: 0;
  transform: translateY(-6px) scale(0.98);
}
.notif-fade-enter-to {
  opacity: 1;
  transform: translateY(0) scale(1);
}
.notif-fade-leave-from {
  opacity: 1;
}
.notif-fade-leave-to {
  opacity: 0;
  transform: translateY(-6px) scale(0.98);
}
</style>
